var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 41,
    viewBox: "0 0 73 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0588 37C68.0588 28.2479 64.6843 19.8542 58.6776 13.6655C52.6709 7.47678 44.5241 4 36.0294 4C27.5347 4 19.3879 7.47677 13.3812 13.6655C7.37452 19.8542 4 28.2478 4 37",
    stroke: "#EAEAF2",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0588 37C68.0588 28.2479 64.6843 19.8542 58.6776 13.6655C52.6709 7.47678 44.5241 4 36.0294 4C27.5347 4 19.3879 7.47677 13.3812 13.6655C7.37452 19.8542 4 28.2478 4 37",
    stroke: "#35A4E8",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastery);
export default __webpack_public_path__ + "static/media/mastery.16fbbf1e982618cc0ea2d6932dcb4c29.svg";
export { ForwardRef as ReactComponent };